export const routes = [
    'validateData',
    'generateFiles',
    'validateCrossFile',
    'generateEF',
    'reviewData'
];

export const steps = {
    validateData: 1,
    generateFiles: 2,
    validateCrossFile: 3,
    generateEF: 4,
    reviewData: 5
};
